// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"0f286987","297":"b4ae899c","351":"ed901568","355":"db061c03","456":"b4724604","495":"4beabb4f","556":"a3447d6e","867":"2f24ac32","891":"b02f9e21"}[chunkId] + ".chunk.js";
};